import { z } from "zod";
import {
  personSchemaBaseFields,
  withEmailConfirmationValidation,
} from "@shared/schemas/sharedSchemas";

export const signupSchemaBaseFields = {
  ...personSchemaBaseFields,
  password: z
    .string()
    .min(8, { message: "Password must be at least 8 characters long" })
    .regex(/[!@#$%^&*(),.?":{}|<>]/, {
      message: "Password must contain at least one special character",
    }),
};

export const loginSchemaBaseFields = {
  email: z.string().email("Invalid email address"),
  password: z
    .string()
    .min(8, { message: "Password must be at least 8 characters long" })
    .regex(/[!@#$%^&*(),.?":{}|<>]/, {
      message: "Password must contain at least one special character",
    }),
};

export const forgotPasswordSchemaBaseFields = {
  email: z.string().email("Invalid email address"),
};

export const resetPasswordSchemaBaseFields = {
  password: z
    .string()
    .min(8, { message: "Password must be at least 8 characters long" })
    .regex(/[!@#$%^&*(),.?":{}|<>]/, {
      message: "Password must contain at least one special character",
    }),
  confirmPassword: z.string(),
};

export const updatePasswordSchemaBaseFields = {
  currentPassword: z
    .string()
    .min(8, { message: "Current password is required" }),
  password: z
    .string()
    .min(8, { message: "Password must be at least 8 characters long" })
    .regex(/[!@#$%^&*(),.?":{}|<>]/, {
      message: "Password must contain at least one special character",
    }),
  confirmPassword: z.string(),
};

export const baseSignupSchema = withEmailConfirmationValidation(
  z.object(signupSchemaBaseFields)
);

export const baseLoginSchema = z.object(loginSchemaBaseFields);

export const baseForgotPasswordSchema = z.object(
  forgotPasswordSchemaBaseFields
);

export const baseResetPasswordSchema = z
  .object(resetPasswordSchemaBaseFields)
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export const baseUpdatePasswordSchema = z
  .object(updatePasswordSchemaBaseFields)
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });
